module.exports = __webpack_public_path__ + "img/icon-contract.6cdf6cca.svg";